<template>

  <a-card>
    <a-space style='width: 100%' direction='vertical'>

      <div style='margin-bottom: 20px' v-if='config.search'>
        <a-input-group compact>
          <a-select style='width: 10%' v-model:value='searchData.field'>
            <a-select-option :disabled='true' value=''>Seçim Yap</a-select-option>
            <a-select-option :hidden='status(column.search)' :key='column' v-for='column in columns' :value='column.dataIndex'>
              {{ column.title }}
            </a-select-option>
          </a-select>
          <a-input style='padding: 7px 11px; width: 20%' v-model:value='searchData.text' />
          <a-button @click='get()' style='height: 38px; line-height: 38px;' type='primary'>
            <sdFeatherIcons type='search' style='color: white' />
          </a-button>
        </a-input-group>
      </div>

      <a-table
          :bordered='true'
          :columns='columns'
          :data-source='data'
          :pagination='pagination'
          :loading='loading'
          :row-key='record => record.id'
          @change='get'
      >

        <template #action='{record}'>
          <a-popconfirm :row='record.id' v-if='config.delete' :title="$t('common.confirm-delete')" :ok-text="$t('common.yes')" :cancel-text="$t('common.no')" @confirm='del(record.id)'>
            <a-button type='danger'>
              <sdFeatherIcons type='trash' style='color: white' />
            </a-button>
          </a-popconfirm>
          &nbsp;
          <a-button v-if='config.edit' @click='detail(record)' type='primary'>
            <sdFeatherIcons type='edit' style='color: white' />
          </a-button>
        </template>

      </a-table>
    </a-space>
  </a-card>

  <a-modal :title="$t('pages.domains.edit')" v-model:visible='modalVisible'>
    <template #footer>
      <a-button @click='modalVisible=false'>{{ $t('common.cancel') }}</a-button>
      <a-button @click='set()'>{{ $t('common.save') }}</a-button>
    </template>

    <a-form layout='vertical'>
      <a-form-item :hidden='status(column.editable)' v-for='column in columns' :label='column.dataIndex'>
        <a-input v-model:value="form[column.dataIndex]"></a-input>
      </a-form-item>
    </a-form>

  </a-modal>

</template>

<script>

import { message } from 'ant-design-vue';

export default {
  name: 'Default',
  props: ['columns', 'endpoints', 'config'],
  components: [message],
  data() {
    return {
      data: [],
      selectedData: {},
      form: {},
      loading: false,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      sortable: {
        field: 'domain',
        order: 'ascend',
      },
      searchData: {
        text: '',
        field: '',
      },
      modalVisible: false,
    };
  },
  methods: {
    get(p, f, s) {
      var _this = this;
      this.loading = true;

      this.setPagination(p);
      this.setFilters(f);
      this.setSortable(s);

      var params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        column: this.sortable.field,
        order: this.sortable.order == 'ascend' ? 'asc' : 'desc',
      };

      if (this.config.search) {
        params.searchText = this.searchData.text;
        params.searchField = this.searchData.field;
      }

      this.$appAxios.get(this.endpoints.get, {
        params: params,
      }).then((response) => {
        _this.data = response.data.data.data;
        _this.pagination.total = response.data.data.total;
        _this.loading = false;
      });
    },
    del(id) {

      var _this = this;

      this.$appAxios.post(this.endpoints.del + '/' + id).then((response) => {
        _this.get();
      });
    },
    set() {

      var _this = this;

      var formdata = new FormData();

      for(const [key, value] of Object.entries(this.form)){
          formdata.append(key, value);
      }

      this.$appAxios.post(this.endpoints.set + '/' + this.selectedData.id, formdata).then((response) => {

          if(!response.data.status){
            _this.$message.error(_this.$t('common.not-empty'));
            return;
          }

          _this.modalVisible = false;

          this.get();
      });
    },
    detail(record) {

      this.selectedData = record;

      for(var i = 0; i < this.columns.length; i++) {
        if(this.columns[i].editable){
          this.form[this.columns[i].dataIndex] = record[this.columns[i].dataIndex];
        }
      }

      if (this.config.editType == 'modal') {
        this.modalVisible = true;
      }

    },
    setPagination(data) {
      if (typeof data == 'undefined') {
        return;
      }

      this.pagination = data;
    },
    setFilters(data) {
      if (typeof data == 'undefined') {
        return;
      }
    },
    setSortable(data) {

      if (typeof data == 'undefined') {
        return;
      }

      if (typeof data.field !== 'undefined') {
        this.sortable.field = data.field;
      }

      if (typeof data.order !== 'undefined') {
        this.sortable.order = data.order;
      } else {
        this.sortable.order = 'ascend';
      }
    },
    status(column) {
      if (typeof column == 'undefined') {
        return true;
      }

      return !column;
    },
  },
  created() {
    this.get();
  }
};
</script>

<style scoped>

</style>